import { useMutation } from "@tanstack/react-query";
import { useInvalidateQueries } from "@/hooks/helperHooks/useInvalidateQueries";
import { editProjectApi } from "@/API/editProjectApi";
import { ShowNotification } from "@/components/ShowNotification";

type EditProjectProps = {
  id: string | null;
  name: string;
  description: string;
  deadline: string | null;
};

const useEditProject = () => {
  const { invalidateProjects } = useInvalidateQueries();

  return useMutation({
    mutationFn: ({ id, name, description, deadline }: EditProjectProps) =>
      editProjectApi(id, name, description, deadline),

    onSuccess: (_data, variables) => {
      invalidateProjects();
      ShowNotification({
        title: "Success",
        message: `${variables.name} has been edited.`,
        color: "success",
      });
    },

    onError: () => {
      ShowNotification({
        title: "Error",
        message: "Failed to edit the project.",
        color: "error",
      });
    },
  });
};

export default useEditProject;
